var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.promotions)?_c('v-row',{attrs:{"wrap":"","dense":""}},_vm._l((_vm.promotions),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"6","sm":"4","md":"3"}},[_c('Cell',{attrs:{"item":item}})],1)}),1):_vm._e(),_c('UpdatePromotion')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }